import { Injectable,EventEmitter } from '@angular/core';
import { NotificationService, NotificationType } from './notification.service';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { HttpClient } from "@angular/common/http";

import { environment } from '../../environments/environment';
import { AuthService } from '../_services/auth.service'


@Injectable()
export class UserService {
  public currentUser: any;
  expTimeOutObject: any;
  UserImgUpdateEvent: EventEmitter<Object> = new EventEmitter();
  UserNameUpdateEvent: EventEmitter<Object> = new EventEmitter();
  selectReleaseEvent:EventEmitter<Object> = new EventEmitter();
  themeChangeEvent = new Subject<boolean>();
  

  constructor(private http: HttpClient, private _auth: AuthService, private _notificationService: NotificationService) {
    this.tokenExpirationTimeOut();
  }

  getConfig(key = null) {
    let configJson = JSON.parse(localStorage.getItem("userConfig"))
    if (key) {
      return configJson[key]
    }
    return configJson
  }

  loadUserInfo(): Promise<any> {
    return new Promise((resolve, reject) => {

      this.http.get(environment.identity_service_api + "user/me").pipe(
        map((response: any) => {
          let response_json = response;
          this.currentUser = response;
         
          localStorage.setItem("userConfig", JSON.stringify(response_json["config"]));
          // localStorage.setItem("UserDetails", JSON.stringify(UserDetails));
  
          if(response_json.theme == 'dark'){
            document.getElementsByTagName('body')[0].classList.remove('light');
            document.getElementsByTagName('body')[0].classList.add('dark');
          } else {
            document.getElementsByTagName('body')[0].classList.remove('dark');
            document.getElementsByTagName('body')[0].classList.add('light');
          }
          
          return response;
        })
      ).subscribe(
        (data) => {
          resolve(data);
        },
        (errData) => {
          reject();
        }
      );
    });
  }

  saveConfigToServer() {
    return this.http.post(environment.identity_service_api + "user/config", this.getConfig())
  }
  getUserRoles() {
    return this.http.get(environment.identity_service_api + "user/get_roles")
  }

  setConfig(key, value) {
    let userConfig = this.getConfig()
    userConfig[key] = value;
    localStorage.setItem("userConfig", JSON.stringify(userConfig))
    return this.saveConfigToServer().toPromise().then(x => {
      
    })
  }

  removeConfig(key) {
    let userConfig = this.getConfig()
    delete userConfig[key];
    localStorage.setItem("userConfig", JSON.stringify(userConfig))
    return this.saveConfigToServer()
  }
  updateUserDetails(params){
    
    return this.http.post(environment.identity_service_api + "user/update_profile",params)
  }
  updatePassword(params){
    return this.http.post(environment.identity_service_api + "user/change_password",params)
  }
  updateProfilePicture(params){
    return this.http.post(environment.identity_service_api + "user/update_profile_photo",params)
  }

  deleteProfilePicture(params){
    return this.http.delete(environment.identity_service_api + "user/remove_profile_photo/"+ params)
  }

  tokenExpirationTimeOut() {
    const authData = JSON.parse(localStorage.getItem("currentUser"));
    if(authData) {
      const currentDate = new Date()
      const exp = authData.expirationTime - currentDate.getTime();
      if(exp > 0) {
        this.expTimeOutObject = setTimeout(
          () => {
            this._auth.refreshToken().subscribe(
              result => {
                console.log("refresh token updated")
                clearTimeout(this.expTimeOutObject)
                this.tokenExpirationTimeOut();
              }, error => {
                console.log(error.error.message);
                this._notificationService.showNotification({
                  message: 'something went wrong',
                  type: NotificationType.error,
                  isLoading: false
                });
              }
            );
        }, exp - 300000);
      } else {
        this._auth.logout();
      }
    }
  }

  setTheme(theme) {
    return this.http.post(environment.identity_service_api + 'user/set_theme', {'theme': theme})
  }

}
